module.exports = __webpack_public_path__ + "img/certificate-5.c9f732da.png";